import React from 'react';
import gitlab from './../../assets/img/gitlab.png';

const EquipoLayout = () => {
    return (
        <section className="topic">
            <h2 id="members"><a href="#members">#</a>Equipo</h2>
            <section className="coreteam">
                <h3 className="topic-title">
                    <i className="nes-icon star"></i>Conoce nuestros talentos ;)
                </h3>{" "}
                <div className="coreteam-members">
                    <section className="nes-container is-dark member-card">
                        <div className="avatar">
                            <img
                                data-src="https://pbs.twimg.com/profile_images/1550319786982121472/9TiSHhJD_400x400.jpg"
                                alt="Aurora Fernández"
                                className=""
                                src="https://pbs.twimg.com/profile_images/1550319786982121472/9TiSHhJD_400x400.jpg"
                            />
                        </div>{" "}
                        <div className="profile">
                            <h4 className="name">Aurora Fernández</h4>{" "}
                            <p>Diseñadora</p>{" "}
                            <div>
                                <a
                                    href="https://www.instagram.com/1710_auro_fernandez/"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="instagram"
                                >
                                    <i className="nes-icon instagram"></i>
                                </a>{" "}
                                <a
                                    href="https://twitter.com/aurora_Fer1710"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="twitter"
                                >
                                    <i className="nes-icon twitter"></i>
                                </a>{" "}
                                <a
                                    href="https://www.linkedin.com/in/aurora-fern%C3%A1ndez-grossi-a07099209/"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="linkedin"
                                >
                                    <i className="nes-icon linkedin"></i>
                                </a>
                                
                            </div>
                        </div>
                    </section>
                    <section className="nes-container is-dark member-card">
                        <div className="avatar">
                            <img
                                data-src="https://pbs.twimg.com/profile_images/1546218405987962880/3P1QEq8H_400x400.jpg"
                                alt="Felipe Monti"
                                className=""
                                src="https://pbs.twimg.com/profile_images/1546218405987962880/3P1QEq8H_400x400.jpg"
                            />
                        </div>{" "}
                        <div className="profile">
                            <h4 className="name">Felipe Monti</h4>{" "}
                            <p>Desarrollador</p>{" "}
                            <div>
                                <a
                                    href="https://instagram.com/el_amigo_monti"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="instagram"
                                >
                                    <i className="nes-icon instagram"></i>
                                </a>{" "}
                                <a
                                    href="https://twitter.com/el_amigo_monti"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="twitter"
                                >
                                    <i className="nes-icon twitter"></i>
                                </a>{" "}
                                <a
                                    href="https://www.linkedin.com/in/felipemonti/"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="linkedin"
                                >
                                    <i className="nes-icon linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </section>
    );
};

export default EquipoLayout;

